export default (type) =>
  [
    'AutoCompleteSearch',
    'BooleanInput',
    'BulkEdit',
    'CatalogActivity',
    'CodeEditor',
    'Color',
    'Date',
    'InlineEditors',
    'Number',
    'Select',
    'Text',
    'TextArea',
  ].includes(type);
